import api from './api';

/** Dashboard-submenu van de opdrachtgever (migratie 187): /api/v1/employer. */
const BASIS = '/v1/employer';

export type ActiepuntSoort = 'BUDGET_VERLENGING' | 'GOVERNANCE_STANDBY' | 'WALLET_RESTOCK';

export interface Actiepunt {
  id: string;
  soort: ActiepuntSoort;
  ernst: 'rood' | 'oranje';
  sinds: string;
  kan_handelen: boolean;
  params: Record<string, string | number | null>;
}

/** Zelfde volgorde als EMPLOYER_SIGNAAL_VENSTERS in de backend. */
export const SIGNAAL_VENSTERS = [
  'crisis',
  'trajecten',
  'financien',
  'samenwerkingen',
  'medewerkers',
  'projecten',
  'opdrachten',
  'berichten',
  'account',
] as const;
export type SignaalVenster = (typeof SIGNAAL_VENSTERS)[number];

export type Kanalen = Record<SignaalVenster, { sms: boolean; email: boolean }>;

export interface ArboPot {
  saldo: number;
  richtprijs: number;
  richtprijs_is_standaard: boolean;
  drempel: number;
  drempel_trajecten: number;
  onder_drempel: boolean;
  trajecten_gedekt: number;
  opwaarderen_min: number;
  opwaarderen_max: number;
  mutaties: Array<{
    id: string;
    soort: 'OPWAARDERING' | 'FACTUUR' | 'CORRECTIE';
    bedrag: number;
    saldo_na: number;
    omschrijving: string | null;
    created_at: string;
    invoice_number: string | null;
  }>;
  open_facturen: Array<{
    id: string;
    invoice_number: string;
    total_amount: number;
    due_date: string;
    status: string;
    betaalbaar_uit_pot: boolean;
  }>;
}

export const ACTIEPUNTEN_KEY = ['employer-actiepunten'];
export const KANALEN_KEY = ['employer-signaal-kanalen'];
export const ARBO_POT_KEY = ['employer-arbo-pot'];

export const employerCockpitApi = {
  actiepunten: async (): Promise<{ items: Actiepunt[] }> => (await api.get(`${BASIS}/action-items`)).data.data,
  besluitVerlenging: async (id: string, akkoord: boolean) =>
    (await api.post(`${BASIS}/action-items/verlengingen/${id}/besluit`, { akkoord })).data.data,
  accordeerOrMandaat: async () => (await api.post(`${BASIS}/or-mandaat`, { bevestigd: true })).data.data,

  kanalen: async (): Promise<{ kanalen: Kanalen; mag_wijzigen: boolean }> =>
    (await api.get(`${BASIS}/notification-settings`)).data.data,
  zetKanaal: async (venster: SignaalVenster, wijziging: { sms?: boolean; email?: boolean }): Promise<{ kanalen: Kanalen; mag_wijzigen: boolean }> =>
    (await api.put(`${BASIS}/notification-settings/${venster}`, wijziging)).data.data,

  arboPot: async (): Promise<ArboPot> => (await api.get(`${BASIS}/wallet`)).data.data,
  zetRichtprijs: async (richtprijs: number | null) => (await api.put(`${BASIS}/wallet/richtprijs`, { richtprijs })).data.data,
  opwaarderen: async (bedrag: number): Promise<{ checkout_url: string }> =>
    (await api.post(`${BASIS}/wallet/opwaarderen`, { bedrag })).data.data,
  betaalFactuur: async (invoiceId: string): Promise<{ saldo: number; invoice_number: string }> =>
    (await api.post(`${BASIS}/wallet/facturen/${invoiceId}/betaal`)).data.data,
};
